import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { Subfolder } from 'signup-ui-lego-core/constants/Subfolder';
export const SubfolderLocale = new Map([[Subfolder.Deutch, Locale.de], [Subfolder.Japanese, Locale.ja], [Subfolder.Spanish, Locale.es], [Subfolder.French, Locale.fr], [Subfolder.Portuguese, Locale.ptBr]]);
export const getSubfolderLocale = domain => {
  return SubfolderLocale.get(domain);
};